import React from "react";
import { createPortal } from "react-dom";
import { MOCR_SECTIONS, MEMBERS, ATTESTATION_TEXT } from "../data/mocrQuestions";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" }) : "—");

export default function MocrPrintSheet({ record }) {
  if (!record) return null;
  return createPortal(
    <div className="mocr-sheet" data-testid="mocr-print-sheet">
      <div className="sheet-head">
        <div>
          <div className="sheet-brand">TRUMBALL, LLC dba EXTENDED COVERAGE HEALTHCARE</div>
          <div className="sheet-title">Monthly Operating &amp; Compliance Review — {record.month}</div>
          <div className="sheet-sub">Companion to ECH-SOP-14.1 · OIG Element 5 · Retain 10 years · CONFIDENTIAL — prepared for the lender file</div>
        </div>
        <div className="sheet-status">
          <div className="sheet-status-line"><b>Status</b> {record.status}</div>
          <div className="sheet-status-line"><b>Issued</b> {fmt(record.issued_date)}</div>
          <div className="sheet-status-line"><b>Closed</b> {fmt(record.closed_at)}</div>
        </div>
      </div>
      {MOCR_SECTIONS.map((meta) => {
        const sec = record.sections?.[meta.key] || { answers: {}, attestation: null };
        return (
          <div className="sheet-section" key={meta.key}>
            <div className="sheet-sec-title">{meta.title} — {meta.lane}</div>
            <table className="sheet-table">
              <tbody>
                <tr><th style={{ width: 44 }}>#</th><th>Question</th><th style={{ width: 120 }}>Answer</th><th style={{ width: 190 }}>Explanation</th></tr>
                {meta.questions.map((q) => (
                  <tr key={q.id}>
                    <td className="q">{q.id}</td>
                    <td>{q.text}</td>
                    <td>{sec.answers?.[q.id]?.answer || "—"}</td>
                    <td>{sec.answers?.[q.id]?.explanation || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="sheet-attest">
              <div className="sheet-attest-text">ATTESTATION — {ATTESTATION_TEXT}</div>
              {sec.attestation ? (
                <div className="sheet-sig">Signed: <i>“{sec.attestation.signature}”</i> — {sec.attestation.name} · {fmt(sec.attestation.date_signed)}</div>
              ) : (
                <div className="sheet-sig">Not attested.</div>
              )}
            </div>
          </div>
        );
      })}
      <div className="sheet-section">
        <div className="sheet-sec-title">Quarterly Attestation (Mar / Jun / Sep / Dec only)</div>
        {MEMBERS.map((m) => {
          const a = (record.quarterly || []).find((x) => x.member === m);
          return (
            <div className="sheet-sig" key={m}>
              {m} — {a ? <>Signed: <i>“{a.signature}”</i> · {fmt(a.date_signed)}</> : "—"}
            </div>
          );
        })}
      </div>
      <div className="sheet-foot">Generated {new Date().toLocaleString("en-US")} from the ECH compliance system · MOCR {record.month} · The month record is the evidence; the History Log is the index.</div>
    </div>,
    document.body
  );
}
